module.exports = __webpack_public_path__ + "img/member3.6a898123.jpg";